/**
 * Page loader
 */
class Loader {

    constructor($container) {

        this.$container = $container;
        this.pageReady = false;
        this.hideInterval = null;

        this.hideDelay = 750;

        this.hideOnReady();

        this.animateLoader();


        document.addEventListener("DOMContentLoaded", () => {
            this.pageReady = true;
        });
    }

    animateLoader() {
        this.$container.find('#loader-grad-1').css({"x": 0});
        this.$container.find('#loader-grad-1').animate({"x": 542}, 800, () => {
            this.animateLoader();
        });
    }

    showThenRedirect($el) {
        this.show();
        let link = $el.attr('href');
        setTimeout(() => {
            location.href = link;
        }, 750)
    }

    hide() {
        this.pageReady = false;

        setTimeout(() => {
            this.$container.animate({'opacity': 0}, 50, () => {
                this.$container.css('z-index', -1);
            });

            clearInterval(this.hideInterval);
            this.hideInterval = null;

        }, this.hideDelay)
    }

    show() {

        this.$container.css('z-index', 99999);
        this.$container.animate({'opacity': 1}, 50, () => {
            this.pageReady = false;
            this.hideOnReady();
        });
    }

    hideOnReady() {
        if (this.pageReady) return this.hide();

        if (!this.hideInterval) {
            this.hideInterval =  setInterval(() => {
                this.hideOnReady();
            }, 100)
        }

    }

}
/**
 * Nav - ovládání menu
 */
class Nav {

    constructor($container, $button, allNavs, $close) {

        this.$button = $button;
        this.$close = $close;
        this.$container = $container;

        if (!this.$container.length) {
            return;
        }

        this.activeClass = 'is-active';
        this.isOpen = false;
        this.firstOpen = true;

        this.navId = this.$container[0].id;
        this.$logo = $('#logo');

        allNavs[this.navId] = this;

        this.allNavs = allNavs;

        this._initEvents();
    }

    open() {
        if (this.isOpen) return;

        if (this.firstOpen) {
            this.onFirstOpen();
            this.firstOpen = false;
        }

        this.closeOtherNavs();
        this.toggleOtherNavsIcons();

        this.isOpen = true;

        this.$logo.hide();

        if (this.allNavs["nav-app"].isOpen) {
            $(".nav-icons-top").hide();
        }

        if (this.allNavs["nav"].isOpen) {
            $(".nav-icons-top").show();
        }

        this.$button.addClass(this.activeClass);
        this.$container.addClass(this.activeClass);
        $("#nav-lang").addClass(this.activeClass);

        $('.nav-icons').css("display", "flex");
        $(".nav-wrapper").addClass('nav-is-open');
        $('html').addClass('of-h nav-is-open');
    }

    close() {
        if (!this.isOpen) return;

        this.toggleOtherNavsIcons();

        this.isOpen = false;

        this.$logo.show();

        this.$button.removeClass(this.activeClass);
        this.$container.removeClass(this.activeClass);

        $('.nav-icons').hide();
        $(".nav-wrapper").removeClass('nav-is-open');
        $('html').removeClass('of-h nav-is-open');
    }

    toggle() {
        if (this.isOpen) this.close();
        else this.open()
    }

    toggleIcon() {
        this.$button.toggleClass('hover');
    }

    closeOtherNavs() {
        for (let nav in this.allNavs) {
            if (this.navId !== nav) this.allNavs[nav].close();
        }
    }

    toggleOtherNavsIcons() {
        for (let nav in this.allNavs) {
            if (this.navId !== nav) this.allNavs[nav].toggleIcon();
        }
    }

    checkScrollPosition(scrollTop, checkHeight) {
        if (scrollTop > 50) {
            $("#logo").addClass("reduce-size");
        } else {
            $("#logo").removeClass("reduce-size");
        }

        if (scrollTop > checkHeight && !this.isOpen && !this.$button.hasClass('scroll-inverse')) {
            this.$button.addClass('scroll-inverse');
            $(".nav-wrapper").addClass(this.activeClass);
            $("#logo").addClass(this.activeClass);
            $("#nav-lang").addClass(this.activeClass);
        } else if (scrollTop < checkHeight && !this.isOpen && this.$button.hasClass('scroll-inverse')) {
            this.$button.removeClass('scroll-inverse');
            $(".nav-wrapper").removeClass(this.activeClass);
            $("#logo").removeClass(this.activeClass);
            $("#nav-lang").removeClass(this.activeClass);
        }
    }

    changeNavBg(target) {
        let $el = $(`[data-nav-bg="${target}"]`);

        if ($el.is(':visible')) return;

        this.$navBgElements.fadeOut(400);
        $el.css('background-image', `url(${$el.data('src')})`).fadeIn(400);
    }

    initNavBg() {

        this.$navBgElements = $(`[data-nav-bg]`);

        this.$navBgElements.each(function () {
            let $el = $(this);
            $el.css('background-image', `url(${$el.data('src')})`);
        });
    }

    onFirstOpen() {
        this.initNavBg()
    }

    _initEvents() {
        let scope = this;

        this.$button.on('click', function () {
            scope.toggle()
        });

        this.$close.on('click', function (e) {
           e.preventDefault();
           scope.close();
        });

        $(".close-layer").on('click', function(e) {
           e.preventDefault();
           scope.close();
        });

        let win = $(window);
        let winHeight = win.height() - 100;

        this.checkScrollPosition(win.scrollTop(), winHeight);
        win.scroll(function () {
            scope.checkScrollPosition(win.scrollTop(), winHeight);
        });

        this.$container.find('[data-nav-bg-target]').on('mouseenter', function () {
            scope.changeNavBg($(this).data('nav-bg-target'));
        })
    }
}

/**
 * Slider - ovládání sliderů na webu
 */
class Slider {

    constructor($container, sliderType) {

        this.$container = $container;
        this.sliderType = sliderType;

        this.options = {
            sliderSmall: {
                item: 1,
                loop: true,
                auto: this.$container.data("auto"),
                pause: this.$container.data("pause"),
                speed: 500,
                nextHtml: '<span class="slider-controls slider-controls-next"></span>',
                prevHtml: '<span class="slider-controls slider-controls-prev"></span>'
            },
            sliderEvents: {
                item: 1,
                loop: true,
                nextHtml: '<span class="slider-controls slider-controls-next">Next</span>',
                prevHtml: '<span class="slider-controls slider-controls-prev">Previous</span>'
            },
            sliderLocality: {
                item: 1,
                loop: true,
                slideMargin: 0,
                nextHtml: '<span class="slider-controls slider-controls-brown slider-controls-next"></span>',
                prevHtml: '<span class="slider-controls slider-controls-brown slider-controls-prev"></span>',
                pager: false,
                onBeforeStart: function($el) {
                    $('.slider-locality-pager button').each(function (i) {
                        $(this).attr('data-slide-index', i+1).on('click', function () {
                            $el.goToSlide(i+1);
                        });
                        if (i === 0) $(this).addClass('active');
                    })
                },
                onBeforeSlide: function ($el) {
                    let index = $el.getCurrentSlideCount();
                    $(`[data-slide-index]`).removeClass('active');
                    $(`[data-slide-index="${index}"]`).addClass('active');
                },
            }
        };

        if (this.sliderType in this.options) {
            this.initLightSlider(this.options[this.sliderType])
        }

    }

    initLightSlider(option) {
        this.$container.lightSlider(option);
    }

}

setTimeout(() => {
    new Slider($('.slider-small .slider-wrapper'), 'sliderSmall');
    new Slider($('.slider-events .slider-wrapper'), 'sliderEvents');
    new Slider($('.slider-locality .slider-wrapper'), 'sliderLocality');
}, 500);

let HpPlayerRotateVal = 0;

class firstHpPlayer {
    constructor(videoContainerId, videoId) {

        this.options = {
            url: 'https://vimeo.com/' + videoId,
            background: 1,
            autoplay: 0,
            autopause: 0,
            muted: 0,
            height: window.innerHeight,
        };

        this.$soundController = $('.mute-sound-in-video');

        this.firstInit = false;

        this.startLoopSequence = 39.18;

        this.activeVideoSection = 0;

        this.progressBarEnd = false;

        this.videoContainerId = videoContainerId;

        this.initPlayer();
    }

    loopThroughSection() {
        this.player.on('timeupdate', (e) => {
            let progressNumber = (e.seconds / this.startLoopSequence)*100;
            if (e.seconds >= 50.20) {
                this.player.setCurrentTime(this.startLoopSequence);
            }
            if (e.seconds >= this.startLoopSequence) {
                $(".skip-video").addClass("d-none");
            }
            if (e.seconds >= this.startLoopSequence) this.progressBarEnd = true;
            if (!this.progressBarEnd) {
                $(".hp-video-progress-bar").width(progressNumber.toFixed(4) + "%");
            }
        });
    }

    skipVideo() {
        this.player.setCurrentTime(this.startLoopSequence);
        $(".skip-video").addClass("d-none");

        return false;
    }

    volumeControl() {
        this.player.getVolume().then((volume) => {
            if (volume === 1) {
                this.player.setVolume(0);
                this.$soundController.find(".fa-volume-up").addClass("d-none");
                this.$soundController.find(".fa-volume-off").removeClass("d-none");

            } else if (volume === 0) {
                this.player.setVolume(1);
                this.$soundController.find(".fa-volume-off").addClass("d-none");
                this.$soundController.find(".fa-volume-up").removeClass("d-none");
            }
        });
    }

    initPlayer() {
        this.player = new Vimeo.Player(this.videoContainerId, this.options);

        this.player.on('loaded', () => {
            this.player.setVolume(0);
            if (this.$soundController.hasClass("volume-up")) {
                this.volumeControl();
            }
            this.player.play();
        });

        $(".mute-sound-in-video").click((e) => {
            e.preventDefault();
            this.volumeControl();
        });

        $(".btn-another-hp-video").click((e) => {
            e.preventDefault();

            this.player.pause();
        });

        $(document).on("click", ".lg-close", () => {
            this.player.play();
        })
    }

    activate() {
        if (!this.firstInit) {
            this.firstInit = true;
            this.loopThroughSection();
        }

        this.player.play();
    }

    deactivate() {
        this.player.pause();
    }
}

/**
 * HomePage Vimeou Player
 */
class HpPlayer {

    constructor(videoContainerId, videoId) {

        this.options = {
            url: 'https://vimeo.com/' + videoId,
            background: 1,
            autoplay: 1,
            autopause: 0,
            height: window.innerHeight,
        };

        this.$progress = $('.hp-video-progress-circle');
        this.$compass = $('#hp-video-compass');
        this.$buttons = $('[data-video-section]');

        this.firstInit = false;

        this.activeVideoSection = 1;

        this.progressBarEnd = false;

        this.videoSections = [
            {
                from: 0.00,
                to: 17.70,
                compass: 0,
                startingPos: 200,
                duration: 9130
            },
            {
                from: 18.00,
                to: 45.90,
                compass: 45,
                startingPos: 160,
                duration: 13000
            },
            {
                from: 46.10,
                to: 70.00,
                compass: 135,
                startingPos: 160,
                duration: 12200
            },
            {
                from: 70.20,
                to: 93.20,
                compass: 180,
                startingPos: 165,
                duration: 11600
            },
            {
                from: 93.50,
                to: 124.80,
                compass: 225,
                startingPos: 120,
                duration: 15800
            },
            {
                from: 127.01,
                to: 140.50,
                compass: 300,
                startingPos: 175,
                duration: 6800
            },
        ];

        this.videoContainerId = videoContainerId;

        this.initPlayer();
        this.initControls();
    }

    initControls() {
        let scope = this;

        /**
         * @desc Zavolá funkci po kliknutí na dannou sekci v kompasu
         * @function setSection
         * @param newSectionIndex
         */
        $('[data-video-section]').on('click', function () {
            scope.setSection(parseInt($(this).data('video-section')));
        })
    }

    stopAnimateProgress() {
        this.$progress.stop();
    }

    /*animateProgress() {
        let animationDuration = (this.videoSections[this.activeVideoSection].to - this.videoSections[this.activeVideoSection].from) * 1250;

        this.$progress.css('text-indent', 205).stop();

        this.$progress.animate({  textIndent: 930 }, {
            step: function(now) {
                $(this).css('-webkit-transform','rotate('+now+'deg)');
            },
            duration: animationDuration
        },'linear');
    }*/

    animateProgress() {
        let currentSection = this.videoSections[this.activeVideoSection];
        let startingPos;

        if (HpPlayerRotateVal === 0) {
            startingPos = currentSection.startingPos;
        } else {
            startingPos = HpPlayerRotateVal;
        }

        this.$progress.stop();

        this.$progress.css('text-indent', startingPos);


        this.$progress.animate({ textIndent: startingPos + 360 }, {
            step: function(now) {
                if (HpPlayerRotateVal === 0) {
                    $(this).css('-webkit-transform', 'rotate(' + now + 'deg)');
                } else {
                    $(this).css('-webkit-transform', 'rotate(' + HpPlayerRotateVal + 'deg)');
                }

                HpPlayerRotateVal = now;
            },
            duration: currentSection.duration,
            easing: 'linear',
            complete: () => {
                this.animateProgress();
            }
        });
    }

    setSection(newSectionIndex) {
        this.activeVideoSection = newSectionIndex;

        HpPlayerRotateVal = 0;

        this.player.setCurrentTime(this.videoSections[this.activeVideoSection].from);
        this.player.play();

        this.$compass.animate({  textIndent: this.videoSections[this.activeVideoSection].compass }, {
            step: function(now) {
                $(this).css('-webkit-transform','rotate('+now+'deg)');
            },
            duration: 800
        },'linear');

        this.$buttons.removeClass('active');
        $('[data-video-section="'+newSectionIndex+'"]').addClass('active');

        $("#hp-video-progress").removeClass("paused");
        this.animateProgress();
    }

    loopThroughSection() {
        this.player.on('timeupdate', (e) => {
            if (e.seconds >= this.videoSections[this.activeVideoSection].to) {
                this.player.setCurrentTime(this.videoSections[this.activeVideoSection].from);
            }
        });
    }

    initPlayer() {
        this.player = new Vimeo.Player(this.videoContainerId, this.options);

        this.player.on('loaded', () => {
            this.player.setVolume(0);
            this.pause();
        });

        $(".hp-video-progress-ring").click(() => {
            if ($("#hp-video-progress").hasClass("paused")) {
                $("#hp-video-progress").removeClass("paused");
                this.player.play();
                this.animateProgress();
            } else {
                $("#hp-video-progress").addClass("paused");
                this.player.pause();
                this.stopAnimateProgress();
            }
        })
    }

    activate() {
        if (!this.firstInit) {
            this.firstInit = true;
            this.loopThroughSection();
        }
        this.setSection(this.activeVideoSection);
    }

    deactivate() {
        this.player.setCurrentTime(this.videoSections[this.activeVideoSection].from);
        this.player.pause();
        this.stopAnimateProgress();
    }

}

/**
 * HomePage Controller
 *
 *
 *
 *
 */
class PageHomepage {

    constructor(hpVideo, hpVideo2) {

        this.hpVideo = hpVideo;
        this.hpVideo2 = hpVideo2;

        this.fullpage = $('#fullpage').fullpage({
            licenseKey: "FBA27AE3-4BDF45C4-98C6198A-2A8BB1F2",
            // anchors:['home', 'video', 'model'],
            keyboardScrolling: true,
            animateAnchor: false,
            recordHistory: false,
            navigation: true,
            navigationPosition: 'right',
            navigationTooltips: ['01', '02', '03'],
            afterLoad: (origin, destination, direction) => {
                this.activeSectionAction(origin, destination, direction)
            },
        });

    }

    activeSectionAction(origin, destination, direction) {
        switch (destination.index) {
            case 0:
                this.hpVideo.activate();
                this.hpVideo2.deactivate();
                break;
            case 1:
                fullpage_api.setAllowScrolling(true);
                this.hpVideo2.activate();
                this.hpVideo.deactivate();
            case 2:
                break;
            case 3:
                fullpage_api.setAllowScrolling(false);
                break;
            default:
                fullpage_api.setAllowScrolling(true);
                this.hpVideo.deactivate();
                this.hpVideo2.deactivate();
                break;
        }
    }

}

/* global gv */
class FormController {

    constructor($form, option) {
        this.gv = gv;
        this.$form = $form;
        this.option = option;
        this.recaptchaSelector = option.recaptchaSelector;
        this.errors = [];
        this.constraints = option.constraints || {};
        this.submitForm = false;
        this.recaptchaVisible = false;

        this.validateOptions = option.validateOptions || {
            fullMessages: false
        };

        this.initEvents();
    }

    validate(e) {
        e.preventDefault();
        let formData = this.$form.serializeArray();
        let forDataForValidate = {};
        formData.map((item) => { if (item.value !== "") forDataForValidate[item.name] = item.value });
        this.errors = validate(forDataForValidate, this.constraints, this.validateOptions);
        if (this.$form.find('.g-recaptcha-response').val() === "") this.setCaptchaError();
        if (this.errors === undefined && this.$form.find('.g-recaptcha-response').val() !== "") this.submit();
        else this.setErrors();

    }

    setCaptchaError() {
        this.$form.find('.g-recaptcha-error-box').fadeIn(200).delay(5000).fadeOut(200);
    }

    setErrors() {
        this.$form.find('.form-error').remove();
        this.$form.find('.form-control').removeClass("input-error");
        for (let key in this.errors) {
            if (!this.errors.hasOwnProperty(key)) continue;
            $(`[name="${key}"]`).data('error', this.errors[key]).addClass("input-error");
            $(`[name="${key}"]`).data('error', this.errors[key]).after(`<div class="form-error"><i class="fa fa-exclamation-triangle"></i> ${this.errors[key]}</div>`);
        }
    }

    submit() {
        this.submitForm = true;

        this.$form.find(".spinner-border").removeClass("d-none");

        let postData = `${this.$form.serialize()}&mact=FormBuilder,cntnt01,default,1&cntnt01fbrp_callcount=1&cntnt01form_id=1&cntnt01lang=en_US&cntnt01fbrp_continue=2&cntnt01fbrp_done=1&cntnt01fbrp_submit=Ulo%C5%BEit%20formul%C3%A1%C5%99`;
        $.post(gv.root_url + '/ajax/form/contact/', postData, (res) => {
            this.afterSubmit(res)
        })
    }

    afterSubmit(res) {
        if (res.success) {
            this.$form[0].reset();
            grecaptcha.reset();
            if (this.gv.cs === 1) {
                console.log('odeslano uspešně');
                swal('Zpráva odeslána', `Děkujeme za Váš zájem. Do Vašeho e-mailu bylo odesláno potvrzení o odeslání zprávy, kterou jste nám poslal/a. <br> V nejbližší době Vás budeme kontaktovat. <br><br> Prodejní tým Daramis`, 'success');
            } else if (this.gv.en === 1) {
                swal('Message sent', `Thank you for your interest. A confirmation message has been sent to your e-mail address. <br> We will contact you in the near future. <br><br> DARAMIS Sales Team`, 'success');
            }
        } else if (res.errors.length || !res.success) {
            swal('Form Error!', 'Při odesílání formuláře nastala chyba. Zkuste obnovit stránku, nebo odešlete formulář později. Omlouváme se za komplikace.', 'warning' );
        }

        this.$form.find(".spinner-border").addClass("d-none");
        this.submitForm = false;
    }

    showRecaptcha()
    {
        $(this.recaptchaSelector).collapse('show');
    }

    initEvents() {
        if (!this.$form[0]) return;

        this.$form.on('submit', (e) => {
            if (!this.submitForm) this.validate(e);
            else e.preventDefault();
        });

        this.$form.find('input, textarea, radio, checkbox, select').on('focus', (e) => {
            if (!this.recaptchaVisible) this.showRecaptcha();
        })
    }

}


let contactMap;
let localityMap;
let infoWindows = [];

/**
 * setMarker() - vloží do mapy marker a vrátí objekt markeru
 * @param map
 * @param marker
 *
 *
 */
function setMarker(map, markerData) {
    function servicesDetailBtn () {
        if (markerData.urlDetail !== '') {
            if (gv.cs === 1) {
                return `<a href="${gv.root_url}/sluzba/${markerData.urlDetail}" class="btn btn-main">DETAIL OBCHODU</a>`;
            } else {
                return `<a href="${gv.root_url}/service/${markerData.urlDetail}" class="btn btn-main">SERVICES DETAIL</a>`;
            }
        } else {
            return '';
        }
    }

    let infoWindow = new google.maps.InfoWindow({
        content: `<div class="info-window-content">
                    ${markerData.content}
                    ${servicesDetailBtn()}
                  </div>`
    });

    let marker = new google.maps.Marker({
        position: markerData.loc,
        map: map,
        icon: {
            url: gv.content_url + markerData.icon.url,
            scaledSize: markerData.icon.scaledSize ? new google.maps.Size(markerData.icon.scaledSize[0], markerData.icon.scaledSize[1]) : null,
        },
        category: markerData.category
    });

    if (markerData.content) {
        infoWindows.push(infoWindow);

        marker.addListener('click', function() {
            for (var i= 0; i<infoWindows.length; i++) {
                infoWindows[i].close();
            }

            infoWindow.open(map, marker);
        });

        $(".map-legend-item").click(function(){

           if ($(this).data("category") === marker.category) {
               if (marker.visible) {
                   marker.setVisible(false);
                   $(this).removeClass("active");
               } else {
                   marker.setVisible(true);
                   $(this).addClass("active");
               }
           }
        });
    }

    return marker;
}


/**
 * Inicializační script pro mapu na /contact stránce
 */
function initContactMap() {
    let container = document.getElementById('map-contact');
        container.style.height = '500px';

    const mapLatLng = {lat: 50.1079576, lng: 14.4543963};

    contactMap = new google.maps.Map(container, {
        center: mapLatLng,
        zoom: 14,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        styles: [
            {
                featureType: 'poi',
                stylers: [{visibility: 'off'}]
            },
            {
                featureType: 'transit',
                elementType: 'labels.icon',
                stylers: [{visibility: 'off'}]
            }
        ]
    });

    setMarker(contactMap,
        {
            loc: mapLatLng,
            icon: {
                url: '/images/logos/DARAMISlogo.png',
            }
        });
}

/**
 * Inicializace mapy na stránce /locality
 */
function initLocalityMap() {

    const mapLatLng = {lat: 50.1049823937063, lng: 14.447873167675766};
    const mapStyles = [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e6e8f8"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}];

    mapStyles.push({"featureType": 'transit',"elementType": 'labels.icon',"stylers": [{"visibility": 'off'}]});
    mapStyles.push({"featureType": 'poi',"stylers": [{"visibility": 'off'}]});

    let options = {
        height: '80vh',
        mapOptions: {
            mapTypeControl: false,
            fullscreenControl: false,
            center: mapLatLng,
            zoom: 15,
            styles: mapStyles,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
        }
    };

    $(".btn-map-legend").click(function(){
        $(this).toggleClass("active");
        $(".map-legend-collapse").toggleClass("active");
        $(".map-legend").toggleClass("active");
    });

    if (typeof mapOptions !== "undefined") {
        options.height = mapOptions.height;
        options.mapOptions.mapTypeControl = mapOptions.showControll;
        options.mapOptions.fullscreenControl = mapOptions.showControll;
    }

    let container = document.getElementById('map-locality');
    container.style.height = options.height;

    localityMap = new google.maps.Map(container, options.mapOptions);

    google.maps.event.addListener(localityMap, 'click', function(event) {
        // console.log('lat: ' + event.latLng.lat());
        // console.log('lng: ' + event.latLng.lng());
        // console.log('--------------------------');
    });

    if (markers_locality !== undefined) {
        markers_locality.forEach(function (marker) {
            setMarker(localityMap, marker)
        })
    }

    // new google.maps.Marker({
    //     position: mapLatLng,
    //     map: contactMap,
    //     title: 'Hello World!',
    //     icon: `${gv.content_url}/images/logos/DARAMISlogo.png`,
    // });
}

/**
 * DataAction controller
 * data-action="<action>"
 *
 */
class DataAction {

    constructor($els) {
        this.$els = $els;
        this._initEvents();
    }

    _checkRequired() {
        return this.$els[0];
    }

    _initEvents() {
        if (!this._checkRequired()) return false;
        let scope = this;
        this.$els.on('click', function (e) {
            e.preventDefault();
            DataAction._doAction($(this).data('action'), $(this));
        });
    }

    static _doAction(action, $el) {
        switch (action) {
            case "show-loader-then-redirect":
                loader.showThenRedirect($el);
                break;
        }
    }

}

/**
 * DataAjax - stahuje a vkládá obsaj jako emaily apod.
 * slouží jako ochrana proti botům, kteří stahují email apod.
 *
 */
class DataAjax {

    constructor() {
        this.$contentEls = $('[data-ajax]');
        this.$mailtoEls = $('[data-ajax-mailto]');
        this.$telEls = $('[data-ajax-tel]');

        this.dataKeys = [];
        this.dataContents = [];

        this._getContents();
    }

    _getContents() {
        let scope = this;

        if (this.$contentEls[0]) this.$contentEls.each(function () { scope.dataKeys.push($(this).data('ajax')) });
        if (this.$mailtoEls[0]) this.$mailtoEls.each(function () { scope.dataKeys.push($(this).data('ajax-mailto')) });
        if (this.$telEls[0]) this.$telEls.each(function () { scope.dataKeys.push($(this).data('ajax-tel')) });

        if (!this.dataKeys.length) return;

        const dataKeys = [...new Set(this.dataKeys)];
        const getRequest = dataKeys.join(',');

        $.get(`${gv.root_url}/ajax/dataajax/?keys=${getRequest}`, (response) => {this._setContents(response)});
    }

    _setContents(contents) {
        if (!contents) return;

        if (this.$contentEls[0]) this.$contentEls.each(function () {
            $(this).text(contents[$(this).data('ajax')])
        });

        if (this.$mailtoEls[0]) this.$mailtoEls.each(function () {
            $(this).attr('href', `mailto:${contents[$(this).data('ajax-mailto')]}`)
        });

        if (this.$telEls[0]) this.$telEls.each(function () {
            $(this).attr('href', `tel:${contents[$(this).data('ajax-tel')]}`)
        });
    }

    _initEvents() {
        if (!this._checkRequired()) return false;
        let scope = this;
        this.$els.on('click', function (e) {
            e.preventDefault();
            DataAction._doAction($(this).data('action'), $(this));
        });
    }

}

/**
 *
 * Nadstavba nad vimeo player.js
 * Dokumentace - https://github.com/vimeo/player.js#embed-options
 */
class FullscreenVimeoPlayer {

    constructor(elId, options, placeholderElId) {

        this.elId = elId;
        this.options = options;

        if (!this.checkRequired()) return;

        this.player = new Vimeo.Player(elId, options);
        this.placeholderEl = document.getElementById(placeholderElId);

        this.videoWidth = 0;
        this.videoHeight = 0;

        this.setSizeTimeout = null;

        this.setSize();
    }

    checkRequired()
    {
        return !!document.getElementById(this.elId)
    }

    setSize()
    {
        let $el = $("#"+this.elId);
        let $iframe = $el.find('iframe');
        let $wrappper = $('#main-page');

        let $placeholder = $('#video-bg-placeholder');
        let $overlay = $('#video-bg-overlay');

        let ww = window.outerWidth;
        let wh = window.outerHeight;

        let h = $wrappper.outerHeight() + 60;
        let w = (h / 9) * 16;
        let l = (w - ww) / 2;

        if (w < ww) {
            w = ww;
            h = (w / 16) * 9;
        }

        $placeholder.height(h);
        $overlay.height(h);

        $el.height(h);
        $iframe.height(h).width(w);

        $(window).on('resize', () => {
            clearTimeout(this.setSizeTimeout);

            this.setSizeTimeout = setTimeout(() => {
                this.setSize()
            }, 800)
        });

        return this;
    }

    fadePlaceholder()
    {
        if (!this.checkRequired()) return;

        this.player.on('play', () => {
            if (!this.placeholderEl) return;
            this.placeholderEl.className += " fade";
            this.getVideoSize();
            this.setSize();
        });

        return this;
    }

    getVideoSize()
    {
        this.player.getVideoWidth().then(val => this.videoWidth = val);
        this.player.getVideoHeight().then(val => this.videoHeight = val);
    }

    autoplay()
    {
        this.player.on('loaded', () => {
            this.fadePlaceholder();
            this.play();
        });
        return this;
    }

    play()
    {
        this.player.play();
        return this;
    }

    stop()
    {
        this.player.stop();
        return this;
    }

    volume(vol = 100)
    {
        this.player.setVolume(vol)
    }

}
class VimeoPlayer {

    constructor(elId, options, placeholderElId) {

        this.elId = elId;
        this.options = options;

        if (!this.checkRequired()) return;

        this.player = new Vimeo.Player(elId, options);
        this.placeholderEl = $('.' + placeholderElId);

        this.videoWidth = 0;
        this.videoHeight = 0;

        this.setSizeTimeout = null;

        this.setSize();
    }

    checkRequired()
    {
        return !!document.getElementById(this.elId)
    }

    setSize()
    {
        let $el = $("#"+this.elId);
        let $iframe = $el.find('iframe');
        let $wrappper = $('#headerSlider');

        let $placeholder = $('.video-bg-placeholder');
        let $overlay = $('#video-bg-overlay');

        let ww = window.outerWidth;
        let wh = window.outerHeight;

        let h = $wrappper.outerHeight() + 60;
        let w = (h / 9) * 16;
        let l = (w - ww) / 2;

        if (w < ww) {
            w = ww;
            h = (w / 16) * 9;
        }

        $placeholder.height(h);
        $overlay.height(h);

        $el.height(h);
        $iframe.height(h).width(w);

        $(window).on('resize', () => {
            clearTimeout(this.setSizeTimeout);

            this.setSizeTimeout = setTimeout(() => {
                this.setSize()
            }, 800)
        });

        return this;
    }

    fadePlaceholder()
    {
        if (!this.checkRequired()) return;

        this.player.on('play', () => {
            if (!this.placeholderEl) return;
            this.placeholderEl.addClass("hide");
            this.getVideoSize();
            this.setSize();
        });

        return this;
    }

    getVideoSize()
    {
        this.player.getVideoWidth().then(val => this.videoWidth = val);
        this.player.getVideoHeight().then(val => this.videoHeight = val);
    }

    autoplay()
    {
        this.player.on('loaded', () => {
            this.fadePlaceholder();
            this.play();
        });
        return this;
    }

    play()
    {
        this.player.play();
        return this;
    }

    pause()
    {
        this.player.pause();
        return this;
    }

    stop()
    {
        this.player.stop();
        return this;
    }

    volume(vol = 100)
    {
        this.player.setVolume(vol)
    }

}

let appVideo;

let localityVideo = new VimeoPlayer('video-full-container', {
    id: 536363355,
    loop: true,
    responsive: true,
    muted: false,
    autoplay: false,
    controls: true,
    title: false
}, 'video-bg-placeholder').fadePlaceholder();

let localityShortVideo = new VimeoPlayer('shortVideo', {
    id: 454660520,
    loop: true,
    background: true,
    responsive: true,
    muted: false,
    autoplay: true,
    title: false
}, 'video-bg-placeholder').fadePlaceholder();

let test = new VimeoPlayer('spirit-of-the-project-01-video', {
    id: 453329914,
    loop: true,
    background: true,
    responsive: true,
    muted: false,
    autoplay: true,
    title: false
}, 'video-bg-placeholder').fadePlaceholder();

$("[data-target='#video-full']").click(function(){
    localityVideo.play();
});

$("[data-target='#app-video-modal']").click(function(){
    appVideo = new VimeoPlayer('app-video', {
        id: 536363355,
        loop: true,
        responsive: true,
        muted: false,
        autoplay: false,
        controls: true,
        title: false
    }, 'video-bg-placeholder').fadePlaceholder();
    appVideo.play();
});

$(".close").click(() => {
    if (appVideo !== undefined) {
        appVideo.pause();
    }

    if (localityVideo !== undefined) {
        localityVideo.pause();
        localityShortVideo.play();
    }
});

$(".modal").click(function(e)
{
    var container = $(".modal-content");

    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        localityVideo.pause();
        appVideo.pause();
        localityShortVideo.play();
    }
});

class cookies {
    constructor() {
        this.agreeBtn = ""

        this.init();
    }

    setCookie (cname,cvalue,exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    checkCookie() {
        var user = this.getCookie("cookieBar");
        var videoVolume = this.getCookie("cookieVideo");

        var h = $(".cookie-bar").height() + 30;

        if (user != "") {
            $(".cookie-bar").css("display", "none");
        } else {
            user = $(".cookie-bar").css("display", "block");
            $("body").addClass("active-cookies");
            $(".nav-wrapper").css("top", "43px");


            if (user != "" && user != null) {
                $(".cookie-agree").on('click', (e) => {
                    e.preventDefault();
                    $("body").removeClass("active-cookies");
                    $(".nav-wrapper").css("top", "0");

                    $(".cookie-bar").hide();
                    this.setCookie("cookieBar", user, 30);
                });
            }
        }

        if (videoVolume === "") {
            $(".mute-sound-in-video").addClass("volume-up");

            this.setCookie("cookieVideo", true, 1);
        }
    }

    init () {
        this.checkCookie();
    }
}

class conceptModel {
    constructor($model) {
        this.$model = $model;
        this.$button = $(".concept-model-button");
        this.$groups = $("#PMI, #Nova, #Island");

        this.activeLayer = '';

        this.init();
    }

    highlightLayer(el) {
        this.activeLayer = $(el).data("switch");

        $(el).addClass("active");
        $(this.$model).find("#" + this.activeLayer).addClass("active");
    }

    unHighlightLayer() {
        this.$button.removeClass("active");
        $(this.$model).find(".active").removeClass("active");
    }

    init() {
        this.$button.click((e) => {
            this.unHighlightLayer();
            this.highlightLayer(e.currentTarget);
        });

        this.$groups.click((e) => {
            this.unHighlightLayer();
            this.highlightLayer(e.currentTarget);
        });
    }
}

// todo
var map;
function initMap() {
    map = new google.maps.Map(document.getElementById('contact-map'), {
        center: {lat: -34.397, lng: 150.644},
        zoom: 8
    });
}

/* global $ */

/**
 * Page loader
 */
class ImagePoints {

    constructor(containerSelector) {
        this.$container = $(containerSelector);
        this.$nav = this.$container.find('.ip-nav');
        this.$navItems = this.$nav.find('.ip-nav-item');
        this.$toggle = this.$container.find('.ip-point-toggle');
        this.$points = this.$container.find('.ip-point');

        this.imagePointSlider = null;

        this.initImageSlider();
        this.initEvents();
        this.checkPointsPosition();
    }

    checkPointsPosition()
    {
        let navWidth = this.$nav.width();
        let ww = $(window).width();

        this.$points.each((i, el) => {
            let $pc = $(el).find('.ip-point-content');
            let pcol = $pc.offset().left;

            if ($pc.hasClass('left') && pcol < navWidth || pcol + $pc.width() > ww) {
                $pc.removeClass('left').addClass('bottom');
            }
        })
    }

    static togglePoint($toggle)
    {
        let $point = $toggle.parent();

        $(".ip-point").removeClass("active");

        $point.find('.ip-point-content').css('z-index', ($point.hasClass('active') ? 'auto' : 100));
        $point.toggleClass('active');
    }

    togglePointSet($toggle)
    {
        let target = $toggle.data('target-set');
        let imageUrl = this.$container.find('[data-image-set="'+target+'"]').attr('src');
        this.$container.find('.ip-points-set.active').fadeOut(300, function () { $(this).removeClass('active'); });
        this.$container.find('[data-set="'+target+'"]').fadeIn().addClass('active');
        this.imagePointSlider.goToSlide(target);
        this.$nav.find('.ip-nav-blur').css('background-image', 'url('+imageUrl+')');
        this.$nav.find('.ip-nav-item.active').removeClass('active');
        $toggle.addClass('active');
    }

    initImageSlider()
    {
        this.imagePointSlider = this.$container.find('.ip-image-slider').lightSlider({
            item: 1,
            controls: false,
            pager: false,
            mode: 'fade'
        });
    }

    initEvents()
    {
        this.$toggle.on('mouseover', (e) => { ImagePoints.togglePoint($(e.target)) });
        this.$navItems.on('click', (e) => { this.togglePointSet($(e.target)) });
    }

}

/**
 * Lazy Loader
 */
class Lazy {

    constructor($items) {
        
        this.$items = $items;
        this.itemsOffsetTop = [];
        this.itemsOffsetLoad = [];

        this.resizeTimeout = null;

        this.wst = 0;
        this.wh = 0;

        this.init();
    }

    initOffsets()
    {
        this.itemsOffsetTop = [];
        this.itemsOffsetLoad = [];

        this.$items.each((i, el) => {
            let $el = $(el);
            this.itemsOffsetTop.push($el.offset().top);
            this.itemsOffsetLoad.push($el.data('lazy-offset') ? parseInt($el.data('lazy-offset')) : 0);
        });
    }

    make(index)
    {
        let el = this.$items[index];
        if (el.lazyLoaded) return;
        el.lazyLoaded = true;
        if (el.dataset.lazy && el.dataset.lazy !== '') eval(el.dataset.lazy)
    }

    onScroll()
    {
        this.itemsOffsetTop.forEach((st, i) => {
            if (st < this.wst + this.wh + this.itemsOffsetLoad[i]) this.make(i);
        })
    }
    
    init()
    {
        if (!this.$items.length) return;

        let $w = $(window);
        this.wst = $w.scrollTop();
        this.wh = $w.height();
        this.initOffsets();

        $w.on('scroll', () => {
            this.wst = $w.scrollTop();
            this.onScroll();
        });
        
        $w.on('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.wh = $w.height();
                this.initOffsets();
            }, 250);
        });
    }
}
class DynamicGallery {

    constructor(video = false) {
        this.video = video;
        this.lg = null;
    }

    static option() {
        return {
            dynamic:            true,
            dynamicEl:          [],
            thumbWidth:         140,
            videoMaxWidth:      '80%',
            loadVimeoThumbnail: false,
            thumbnail:          false,
            fullscreen:         false,
            pager:              true,
            videojs:            true,
            download:           false,
            auto:               false,
            zoom:               false,
        }
    }

    static slide(index) {
        setTimeout(() => DynamicGallery.lg.data('lightGallery').slide(index));
        return this;
    }

    static init(targetSelector) {

        if (typeof targetSelector === 'undefined') return;

        DynamicGallery.lg = $(targetSelector);

        if (DynamicGallery.lg.find('div').length < 1) return;

        let option = DynamicGallery.option();

        DynamicGallery.lg.find('div').each(function() {
            let $item = $(this);
            let dynamicElement = {
                src: $item.data('src'),
                iframe: $item.data('iframe'),
                thumb: $item.data('thumb'),
                //subHtml: $item.data('sub-html')
            };

            option.dynamicEl.push(dynamicElement);
        });

        DynamicGallery.lg.lightGallery(option);

        return this;
    }

}

/* global $ */

var loader = new Loader($('#loader'));

var allMenus = {};
new Nav( $('#nav'), $('#nav-icon button'), allMenus, $(".js-close-app"));
new Nav( $('#nav-app'), $('#nav-app-icon button'), allMenus, $(".js-close-app"));

new DataAction( $('[data-action]') );

new DataAjax();

new Lazy($('[data-lazy]'));

$(function(){
    $('#pricelist-table').DataTable({
        fixedHeader: true,
        paging: false,
        info: false,
        searching: false,
        ordering: false,
        "oLanguage": {"sZeroRecords": "", "sEmptyTable": ""}
    });
});

var contactForm;

if (gv.cs === 1) {
    contactForm = new FormController($('#contact-form'), {
        constraints: {
            "cntnt01fbrp__1": {presence: {message: "Pole 'Jméno' je povinné"}},
            "cntnt01fbrp__2": {presence: {message: "Pole 'Příjmení' je povinné"}},
            "cntnt01fbrp__4": {presence: {message: "Pole 'telefon' je povinné"}},
            "cntnt01fbrp__5": {presence: {message: "Pole 'Zpráva' je povinné"}},
            "cntnt01fbrp__3": {presence: {message: "Pole 'Email' je povinné"}, email: {message: "E-mail je neplatný"},},
        },
        recaptchaSelector: '#contact-form-recaptcha'
    });
} else {
    contactForm = new FormController($('#contact-form'), {
        constraints: {
            "cntnt01fbrp__1": {presence: {message: "First name field is required"}},
            "cntnt01fbrp__2": {presence: {message: "Last name field is required"}},
            "cntnt01fbrp__4": {presence: {message: "Phone field is required"}},
            "cntnt01fbrp__5": {presence: {message: "Your message is empty"}},
            "cntnt01fbrp__3": {presence: {message: "E-mail field is required"}, email: {message: "E-mail is invalid"},},
        },
        recaptchaSelector: '#contact-form-recaptcha'
    });
}

switch (gv.page_alias) {
    case 'uvod':
    case 'home':
        var hpVideo = new firstHpPlayer( 'hp-video', '458968510');
        var secondHpVideo = new HpPlayer('second-hp-video', '461113446');
        var pageHp = new PageHomepage( hpVideo, secondHpVideo );

        break;
    case 'apartments':
    case 'typy-bytu':
        setTimeout(() => {
            var ipPoints = new ImagePoints( '#image-points-wrapper' );
        }, 700)
        break;
    case 'koncept':
    case 'concept':
        setTimeout(() => {
            var concept = new conceptModel( '.concept-model' );
        }, 500);
        break;
}

$(function() {
    new cookies();

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
    // $("[data-src]").unveil();

    $('[data-dynamic-gallery]').on('click', function () {
        DynamicGallery.init($(this).data('dynamic-gallery'));
        if ($(this).data('slide')) DynamicGallery.slide(parseInt($(this).data('slide')));
    });

    $(".vimeo-player").each(function () {
        this.vimeoPlayer = new VimeoPlayer($(this));
    })

    new FullscreenVimeoPlayer('video-bg', {
        id: 438593598,
        loop: true,
        background: true,
        responsive: true,
        muted: true,
        autoplay: true,
        title: false
    }, 'video-bg-placeholder').fadePlaceholder();

    $(".btn-scroll-down").on('click', function() {
        $('body,html').animate({ scrollTop: $(window).height() }, 800);
    })

    let ww = window.outerWidth;
    let wh = window.outerHeight;

    let h = $("#hp-video").outerHeight() + 60;
    let w = (h / 9) * 16;
    let l = (w - ww) / 2;


    if (w < ww) {
        w = ww;
        h = (w / 16) * 9;
    }
    setTimeout(function(){
        $("#hp-video iframe, #second-hp-video iframe").height(h).width(w);
    }, 500);

    $(window).on('resize', () => {
        clearTimeout(this.setSizeTimeout);

        this.setSizeTimeout = setTimeout(() => {
            let ww = window.outerWidth;
            let wh = window.outerHeight;

            let h = $("#hp-video").outerHeight() + 60;
            let w = (h / 9) * 16;
            let l = (w - ww) / 2;

            if (w < ww) {
                w = ww;
                h = (w / 16) * 9;
            }

            $("#hp-video iframe, #second-hp-video iframe").height(h).width(w);
        }, 1000)
    });

    $("#model-info-btn a").click((e) => {
        e.preventDefault();
        const ID_INFO_BOX = $("#info-box");

        $(".model-instruction").addClass("active");
    });

    $(".model-instruction-close").click((e) => {
       e.preventDefault();

       $(".model-instruction").removeClass("active");
    });
});
